import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["contentTab", "contentPanel"];

  connect() {}

  switchTab(event) {
    const clickedTab = event.currentTarget;
    const contentType = clickedTab.dataset.contentType;

    this.contentTabTargets.forEach((tab) => {
      if (tab === clickedTab) {
        tab.classList.remove(
          "text-slate-500",
          "hover:text-indigo-600",
          "dark:text-slate-400",
          "dark:hover:text-indigo-400"
        );
        tab.classList.add(
          "border-b-2",
          "border-indigo-500",
          "text-indigo-600",
          "dark:text-indigo-400",
          "dark:border-indigo-400"
        );
      } else {
        tab.classList.remove(
          "border-b-2",
          "border-indigo-500",
          "text-indigo-600",
          "dark:text-indigo-400",
          "dark:border-indigo-400"
        );
        tab.classList.add(
          "text-slate-500",
          "hover:text-indigo-600",
          "dark:text-slate-400",
          "dark:hover:text-indigo-400"
        );
      }
    });

    this.contentPanelTargets.forEach((panel) => {
      if (panel.dataset.contentType === contentType) {
        panel.classList.remove("hidden");
      } else {
        panel.classList.add("hidden");
      }
    });
  }
}
